import Multiselect from "multiselect-react-dropdown";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { withTranslation } from "react-i18next";
import { BiInfoCircle, BiPlusCircle } from "react-icons/bi";
import { toast } from "react-toastify";
import { RegulationContext } from "../../../../App";
import EmissionVersionFields from "../../../../components/EmissionVersionFields/EmissionVersionFields";
import { LS_AUTHORITY_KEY, MetricCategory, USER_ROLE } from "../../../../core/constants/common";
import StandardService from "../../../../core/service/StandardService";
import "./CreateMetric.scss";
import { FiDelete } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import ESGDataSetService from "../../../../core/service/ESGDataSetService";
import LanguageSelector from "../../LanguageSelector/LanguageSelector";
import GHGEmissionService from "../../../../core/service/GHGEmissionService";

const CreateMetric = ({
  t,
  topicId,
  editMetricId,
  answerMode = false,
  handleDiscard,
  handleSave,
  forESGDataSet = false,
  showQuestions = true
}) => {
  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const containerRef = useRef(null);
  const [validated, setValidated] = useState(false);
  const [paramname, setParamName] = useState("");
  const [measuringunit, setMeasuringUnit] = useState("");
  const [code, setCode] = useState("");
  const [isEdit, setIsEdit] = useState(editMetricId ? true : false);
  const [category, setCategory] = useState("");
  const categoryOptions = MetricCategory({ t });
  const { setGlbRegulations, glbRegulation } = useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ?? "";
  const companyId = authority?.profile?.company?.id;
  const [uomList, setUOMList] = useState([]);
  const [relevantUoms, setRelevantUoms] = useState([]);
  const [inputUOMList, setInputUOMList] = useState([]);
  const [dataPointBased, setDataPointBased] = useState(false);
  const [internalCode, setInternalCode] = useState("");
  const [value, setValue] = useState("");
  const [isStdTemplateConfig, setIsStdTemplateConfig] = useState(false);
  const [question, setQuestion] = useState(showQuestions ? {
    question: "",
    helpText: "",
    sampleAnswer: "",
    code: "",
    children: [],
    singleAnswer: true
  } : null);
  const [kpi, setKPI] = useState(false);
  const [periodic, setPeriodic] = useState(false);
  const [localizationData, setLocalizationData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [primaryLangName, setPrimaryLangName] = useState();
  const [isLanguageAvailable, setIsLanguageAvailable] = useState(true);
  const [emission, setEmission] = useState(false);
  const [selectedScope, setSelectedScope] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [scopeData, setScopeData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [helpText, setHelpText] = useState('');
  const [verticalCalcEnabled, setVerticalCalcEnabled] = useState(false);
  const [emissionDatabase, setEmissionDatabase] = useState("");
  const [emissionVersionRef, setEmissionVersionRef] = useState("");
  const [editEmissionDatabase, setEditEmissionDatabase] = useState("");
  const [editEmissionVersionRef, setEditEmissionVersionRef] = useState("");

  useEffect(() => {
    // containerRef.current.scrollIntoView();
    if (window.location.href.includes('std_template_config')) {
      setIsStdTemplateConfig(true);
    }
    let lsLangAvailable = localStorage.getItem('languageAvailable');
    if (lsLangAvailable) {
      setIsLanguageAvailable(JSON.parse(lsLangAvailable));
    }
    setCode("");
    setParamName("");
    setMeasuringUnit("");
    setCategory("");


    setValidated(false);
    setIsEdit(editMetricId ? true : false);
    if (!editMetricId) {
      setIsLoaded(true);
    }
    editMetricId && getDetails(editMetricId);
  }, [isStdTemplateConfig, editMetricId]);

  useEffect(() => {
    getDetailsOfTable();
  }, []);

  const saveData = (e) => {
    e.preventDefault();
    let params = {
      category: category,
      code: code,
      dataPointBased: dataPointBased,
      emission: emission,
      scope: emission ? selectedScope : null,
      scopeCategory: emission ? selectedCategory : null,
      emissionDatabase: emission ? emissionDatabase : null,
      emissionVersionRef: emission ? emissionVersionRef : null,
      helpText: helpText || null,
      verticalCalcEnabled: verticalCalcEnabled
    };
    if (category !== 'QUALITATIVE') {
      params.unitOfMeasure = measuringunit;
      params.relevantUoms = relevantUoms;
      params.kpi = kpi;
    } else {
      params.unitOfMeasure = '';
      params.internalCode = internalCode;
      params.question = question;
      params.periodic = periodic;
    }

    if (category) {
      if (!validateEmissionFields()) {
        setValidated(true);
        return;
      }

      let req;
      if (forESGDataSet) {
        params.name = paramname.trim();
        params.active = true;
        params.mandatory = false;
        params.branchBased = dataPointBased;
        req = ESGDataSetService.addMetric(topicId, params);
      } else if (isStdTemplateConfig || !isLanguageAvailable) {
        params.name = paramname.trim();
        req = StandardService.addMetric(params, topicId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      } else {
        params.localizedContents = localizationData;
        params.name = primaryLangName.trim();
        req = StandardService.addMetric(params, topicId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      }
      req.then((response) => {
        if (response.status === 201 || response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setCode("");
          setParamName("");
          setMeasuringUnit("");
          setCategory("");
          setValidated(false);
          setEmission(false);
          setSelectedScope("");
          setSelectedCategory("");
          setEmissionDatabase("");
          setEmissionVersionRef("");
          setHelpText('');
          setVerticalCalcEnabled(false);
          handleSave(topicId);
        }
      })
        .catch((error) => { });
    }
    setValidated(true);
  };


  const handleEdit = (e) => {
    e.preventDefault();
    const params = {
      category: category,
      dataPointBased: dataPointBased,
      emission: emission,
      scope: emission ? selectedScope : null,
      scopeCategory: emission ? selectedCategory : null,
      emissionDatabase: emission ? emissionDatabase : null,
      emissionVersionRef: emission ? emissionVersionRef : null,
      helpText: helpText || null,
      verticalCalcEnabled: verticalCalcEnabled
    };
    if (category !== 'QUALITATIVE') {
      params.code = code;
      params.unitOfMeasure = measuringunit
      params.relevantUoms = relevantUoms;
      params.kpi = kpi;
    } else {
      params.unitOfMeasure = '';
      params.code = code;
      params.internalCode = internalCode;
      params.question = question;
      params.periodic = periodic;
      if (answerMode) {
        params.value = value;
      }
    }

    if (category) {
      if (!validateEmissionFields()) {
        setValidated(true);
        return;
      }

      let req;
      if (forESGDataSet) {
        params.name = paramname.trim();
        params.id = editMetricId;
        params.active = true;
        params.mandatory = false;
        params.branchBased = dataPointBased;
        req = ESGDataSetService.updateMetric(params);
      } else if (isStdTemplateConfig || !isLanguageAvailable) {
        params.name = paramname.trim();
        req = StandardService.editMetric(params, editMetricId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      } else {
        params.localizedContents = localizationData;
        params.name = primaryLangName.trim();
        req = StandardService.editMetric(params, editMetricId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      }
      if (!(params.name)) {
        setValidated(true);
        return;
      }
      req.then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setValidated(false);
          handleSave(topicId);
        }
      })
        .catch((error) => { });
    }
    setValidated(true);
  };
  const closeMetric = (e) => {
    e.preventDefault();
    handleDiscard(true);
  };
  const getDetails = (editId) => {
    let req;
    if (forESGDataSet) {
      req = ESGDataSetService.getMetric(editId, topicId);
    } else {
      req = StandardService.getMetricDetails(editId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    }
    req.then((response) => {
      const metricRes = forESGDataSet ? response.data.data[0] : response.data;
      if (!forESGDataSet && !isStdTemplateConfig && isLanguageAvailable) {

        if (metricRes?.localizedContents.length > 0) {
          setLocalizationData(metricRes?.localizedContents);
        } else {
          const objLocal = {
            fieldName: 'name',
            languageCode: "",
            translatedValue: metricRes?.name
          }
          setLocalizationData([objLocal]);
        }
      }
      setCode(metricRes?.code);
      setParamName(metricRes?.name);
      setMeasuringUnit(metricRes?.unitOfMeasure);
      setCategory(metricRes?.category);
      setRelevantUoms(metricRes?.relevantUoms ?? []);
      setDataPointBased(metricRes?.dataPointUnitBased ?? false);
      setEmission(metricRes?.emission ?? false);
      setEmissionDatabase(metricRes?.emissionDatabase || metricRes?.database || "");
      setEmissionVersionRef(metricRes?.emissionVersionRef || metricRes?.versionRef || "");
      setEditEmissionDatabase(metricRes?.emissionDatabase || metricRes?.database || "");
      setEditEmissionVersionRef(metricRes?.emissionVersionRef || metricRes?.versionRef || "");
      setHelpText(metricRes?.helpText || '');
      setVerticalCalcEnabled(metricRes?.verticalCalcEnabled ?? false);

      if (metricRes?.emission) {
        setSelectedScope(metricRes.scope || "");
        setSelectedCategory(metricRes.scopeCategory || "");
        const db = metricRes.emissionDatabase || metricRes.database;
        const versionRef = metricRes.emissionVersionRef || metricRes.versionRef;
        if (versionRef && db) {
          GHGEmissionService.getVersionScopeDetails(versionRef, db)
            .then((response) => {
              if (response.status === 200) {
                const scopeList = response.data?.data ?? response.data ?? [];
                setScopeData(Array.isArray(scopeList) ? scopeList : []);
                const selectedScopeData = scopeList.find((scope) => scope.name === metricRes.scope);
                if (selectedScopeData?.categories) {
                  setCategoryData(
                    selectedScopeData.categories.map((cat) => cat.name)
                  );
                }
              }
            })
            .catch(() => { });
        }
      } else {
        setSelectedScope("");
        setSelectedCategory("");
      }

      setIsLoaded(true);
      if (metricRes?.category === 'QUALITATIVE') {
        setInternalCode(metricRes?.internalCode ?? '');
        setValue(metricRes?.value ?? '');
        setQuestion(metricRes?.question ?? null);
        setPeriodic(metricRes?.periodic);
      } else {
        setKPI(metricRes?.kpi);
      }
    })
      .catch((error) => { });
  };
  const getDetailsOfTable = () => {
    StandardService.getUnitsOfMeasure()
      .then((response) => {
        if (response.status !== 200) return;

        const outputList = [], inputList = [];
        for (let index = 0; index < response.data.data.length; index++) {
          const element = response.data.data[index];
          outputList.push({
            id: element.id,
            label: element.outputUnitName,
            value: element.outputUnit
          });
          inputList.push({
            id: element.id,
            label: element.inputUnitName,
            value: element.inputUnit
          });
        }
        const uniqueOutputArray = Array.from(new Set(outputList.map(obj => obj.value))).map(
          value => outputList.find(obj => obj.value === value)
        );
        uniqueOutputArray.sort((a, b) => a.value.localeCompare(b.value));
        const uniqueInputArray = Array.from(new Set(inputList.map(obj => obj.value))).map(
          value => inputList.find(obj => obj.value === value)
        );
        uniqueInputArray.sort((a, b) => a.value.localeCompare(b.value));
        setUOMList(uniqueOutputArray);
        setInputUOMList(uniqueInputArray);
      })
      .catch((error) => { });
  }


  const onSelectDeSelectUoms = (selectedItem) => {
    const uoms = [...relevantUoms];
    const index = relevantUoms.indexOf(selectedItem.value);
    if (index >= 0) {
      uoms.splice(index, 1);
    } else {
      uoms.push(selectedItem.value);
    }
    setRelevantUoms(uoms);
  };

  const getSelectedUoms = (uoms) => {
    const data = [];
    uoms?.forEach(uom => {
      const match = inputUOMList.find(u => u.value === uom);
      if (!match) return;

      data.push(match);
    });
    return data;
  };

  const renderAnswerModeFields = () => {
    if (category !== 'QUALITATIVE' || !authority.roles.includes("SUBSCRIBER_ADMIN")) return <></>;

    return (
      <>
        <div className="col-lg-4 p-2">
          <label className="mb-1">{t("SampleAnswer.label")}</label>
          <textarea
            rows='10'
            className="form-control"
            value={value}
            onChange={(e) => setValue(e.target.value)}>
          </textarea>
        </div>
      </>
    );
  };
  const convertedDataVal = (data, nameVal) => {
    setPrimaryLangName(nameVal);
    setLocalizationData(data);
  }
  const renderEditModeFields = () => {
    return (
      <>
        {(forESGDataSet || isStdTemplateConfig || !isLanguageAvailable) ? <div className="col-lg-12 p-0">
          <label className="mb-1">{t("Metric.label")} <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            value={paramname}
            onChange={(e) => setParamName(e.target.value)}
            required
            maxLength={250}
          />
        </div>
          : <div className="col-lg-12 p-0">
            <LanguageSelector fieldLabel={t("Metric.label")} convertedData={(data, nameVal) => convertedDataVal(data, nameVal)} localizationData={localizationData} />
          </div>}
        <div className="col-lg-5 p-2">
          <label className="mb-1">{t("Category.label")} <span className="text-danger">*</span></label>
          <select
            className="form-select"
            required
            onChange={(e) => setCategory(e.target.value)}
            value={category}>
            <option value="" disabled hidden>
              {t("Select.label")}
            </option>
            {categoryOptions?.map((items) => (
              <option value={items.value} key={items.value}>
                {items.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-2 p-2">
          <label className="mb-1 white-nowrap">{t("DisplayCode.label")} <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            maxLength={250}
          />
        </div>
        {category == 'QUALITATIVE' &&
          <div className="col-lg-2 p-2">
            <div className="mt-3">
              <input className="form-check-input" type="checkbox"
                id='periCheckbox'
                checked={periodic}
                onChange={() => setPeriodic(!periodic)} />
              <label className="form-check-label mx-1" htmlFor='periCheckbox'>
                {t("Periodic.label")}
              </label>
            </div>
          </div>
        }
        {
          category !== 'QUALITATIVE' &&
          <>
            <div className="col-lg-5 p-2">
              <label className="mb-1">{t("MeasuringUnit.label")} <span className="text-danger">*</span></label> 
              {
                uomList?.length > 0 &&
                <Typeahead
                  id="measuringUnit"
                  key="measuringUnit"
                  clearButton
                  selected={uomList.filter(u => u.value === measuringunit)}
                  labelKey={(option) => option.label}
                  onChange={(selected) => {
                    if (selected.length > 0) {
                      setMeasuringUnit(selected[0].value);
                    } else {
                      setMeasuringUnit("");
                    }
                  }}
                  options={uomList}
                  placeholder={t("Search.label")}
                  inputProps={{ required: true }}
                />
              }
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1">
                {t("PossibleUOMs.label")}
              </label>
              <Multiselect
                id="uomMultiselect"
                key="uomMultiselect"
                options={inputUOMList}
                selectedValues={getSelectedUoms(relevantUoms)}
                onSelect={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                onRemove={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                displayValue="label"
              />
            </div>
            <div className="col-lg-8 p-2">
              <div className="mt-3 d-flex gap-3">
                <div>
                  <input className="form-check-input" type="checkbox"
                    id='kpiCheckbox'
                    checked={kpi}
                    onChange={() => setKPI(!kpi)} />
                  <label className="form-check-label mx-1" htmlFor='kpiCheckbox'>
                    {t("KPI.label")}
                  </label>
                </div>
                <div>
                  <input className="form-check-input" type="checkbox"
                    id='emissionCheckbox'
                    checked={emission}
                    onChange={handleEmissionToggle} />
                  <label className="form-check-label mx-1" htmlFor='emissionCheckbox'>
                    {t("Emission.label")}
                  </label>
                </div>
                <div>
                  <input className="form-check-input" type="checkbox"
                    id='verticalCalcCheckbox'
                    checked={verticalCalcEnabled}
                    onChange={() => setVerticalCalcEnabled(!verticalCalcEnabled)} />
                  <label className="form-check-label mx-1" htmlFor='verticalCalcCheckbox'>
                    {t("VerticalCalculationNeeded.label")}
                  </label>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="vertical-calc-tooltip">{t("VerticalCalculationNeeded.tooltip.label")}</Tooltip>}
                  >
                    <span className="ms-1 d-inline-flex align-items-center" role="img" aria-label={t("VerticalCalculationNeeded.tooltip.label")}>
                      <BiInfoCircle size={16} className="text-muted" />
                    </span>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            {emission && (
              <div className="col-lg-12 p-2 emission-config-section">
                <EmissionVersionFields
                  key={`${editMetricId}-${editEmissionDatabase}-${editEmissionVersionRef}`}
                  companyId={companyId}
                  glbRegulationId={glbRegulationId}
                  editDatabase={isEdit ? editEmissionDatabase : ""}
                  editVersionRef={isEdit ? editEmissionVersionRef : ""}
                  onScopeDataChange={setScopeData}
                  onScopeCategoryReset={resetEmissionScopeSelection}
                  onConfigChange={handleEmissionConfigChange}
                />
                <div className="row mt-2">
                  <div className="col-md-6">
                    <label className="mb-1">{t("Scope.label")}</label>&nbsp;*
                    <select
                      className="form-select"
                      value={selectedScope}
                      onChange={handleScopeChange}
                      required
                      disabled={!emissionVersionRef}>
                      <option value="">{t("Select.label")}</option>
                      {scopeData.map((scope) => (
                        <option key={scope.name} value={scope.name}>
                          {scope.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="mb-1">{t("Category.label")}</label>&nbsp;*
                    <select
                      className="form-select"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      required
                      disabled={!selectedScope}>
                      <option value="">{t("Select.label")}</option>
                      {categoryData.map((category) => (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}
          </>
        }
        {/* ...Required Later... */}
        {/* {
          category !== 'QUALITATIVE' &&
          <div className="col-lg-4 p-2">
            <div className="mt-3">
              <input className="form-check-input" type="checkbox"
                id='dpbasedCheckbox'
                checked={dataPointBased}
                onChange={() => setDataPointBased(!dataPointBased)} />
              <label className="form-check-label mx-1" htmlFor='dpbasedCheckbox'>
                {t("DatapointBased.label")}
              </label>
            </div>
          </div>
        } */}
        {
          category === 'QUALITATIVE' && showQuestions &&
          <>
            {renderQuestionFields(question)}
          </>
        }
        <div className="col-lg-12 p-2">
          <label className="mb-1">{t("HelpText.label")}</label>
          <textarea
            className="form-control"
            value={helpText}
            onChange={(e) => setHelpText(e.target.value)}
            rows={3}
            placeholder={t("HelpText.placeholder.label") || "Enter help text"}
          />
        </div>
      </>
    );
  };

  const renderQuestionFields = (question) => {
    if (!question) {
      return (
        <a className="text-primary cursor mx-2" onClick={() => onAddQuestion()}>
          <Button variant="outline-primary"><BiPlusCircle className="me-2"></BiPlusCircle>{t('AddQuestion.label')}</Button>
        </a>
      );
    }
    return (
      <>
        <div className="card p-0 m-2">
          <div className="card-header">
            <span className="float-left">{t('Question.label')}</span>
            <span className="float-right cursor" onClick={() => setQuestion(null)}><AiOutlineDelete /></span>
          </div>
          <div className="card-body row">
            <div className="col-lg-4 p-2">
              <label className="mb-1">{t("Question.label")}</label>&nbsp;*
              <textarea
                rows='5'
                className="form-control"
                value={question.question}
                onChange={(e) => setQuestion({ ...question, question: e.target.value })}
                required>
              </textarea>
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1">{t("HelpText.label")}</label>&nbsp;*
              <textarea
                rows='5'
                className="form-control"
                value={question.helpText}
                onChange={(e) => setQuestion({ ...question, helpText: e.target.value })}
                required>
              </textarea>
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1">{t("SampleAnswer.label")}</label>
              <textarea
                rows='5'
                className="form-control"
                value={question.sampleAnswer}
                onChange={(e) => setQuestion({ ...question, sampleAnswer: e.target.value })}>
              </textarea>
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1">{t("QuestionCode.label")}</label>
              <input
                type="text"
                className="form-control"
                value={question.code}
                onChange={(e) => setQuestion({ ...question, code: e.target.value })}
                maxLength={50}
              />
            </div>
            <div className="col-lg-12 p-2">
              <div className="d-flex align-items-inline">
                <input className="form-check-input" type="checkbox"
                  id='singleAnswerCheckbox'
                  checked={question.singleAnswer}
                  onChange={() => setQuestion({ ...question, singleAnswer: !question.singleAnswer })} />
                <label className="form-check-label mx-1" htmlFor='singleAnswerCheckbox'>
                  {t("SingleAnswer.label")}
                </label>
              </div>
            </div>
          </div>
        </div>
        {question.children?.length > 0 && <h6>{t('SubQuestions.label')}</h6>}
        {
          question.children?.map((child, cIndex) => {
            return renderSubQuestionFields(child, cIndex);
          })
        }
        <div className="col-lg-12 py-1 px-2">
          <a className="text-primary cursor mx-2" onClick={() => onAddNewSubQuestion()}>
            <Button variant="outline-primary"><BiPlusCircle className="me-2"></BiPlusCircle>{t('AddSubQuestion.label')}</Button>
          </a>
        </div>
      </>
    );
  };

  const renderSubQuestionFields = (q, qIndex) => {
    return (
      <div className="col-lg-12 py-1 px-2">
        <div className="card" id={`subQuestion-${qIndex}`} key={`subQuestion-${qIndex}`}>
          <div className="card-header">
            <span className="float-left">{t('SubQuestion.label')} {qIndex + 1}</span>
            <span className="float-right cursor" onClick={() => onDeleteSubQuestion(qIndex)}><AiOutlineDelete /></span>
          </div>
          <div className="card-body">
            <div className="row  m-0">
              <div className="col-lg-4 p-2">
                <label className="mb-1">{t("Question.label")}</label>&nbsp;*
                <textarea
                  rows='5'
                  className="form-control"
                  value={q.question}
                  onChange={(e) => onSubQuestionValChange(qIndex, e.target.value)}
                  required>
                </textarea>
              </div>
              <div className="col-lg-4 p-2">
                <label className="mb-1">{t("HelpText.label")}</label>&nbsp;*
                <textarea
                  rows='5'
                  className="form-control"
                  value={q.helpText}
                  onChange={(e) => onSubQuestionHelpTextChange(qIndex, e.target.value)}
                  required>
                </textarea>
              </div>
              <div className="col-lg-4 p-2">
                <label className="mb-1">{t("SampleAnswer.label")}</label>
                <textarea
                  rows='5'
                  className="form-control"
                  value={q.sampleAnswer}
                  onChange={(e) => onSubQuestionAnswerChange(qIndex, e.target.value)}>
                </textarea>
              </div>
              <div className="col-lg-4 p-2">
                <label className="mb-1">{t("QuestionCode.label")}</label>
                <input
                  type="text"
                  className="form-control"
                  value={q.code}
                  onChange={(e) => onSubQuestionCodeChange(qIndex, e.target.value)}
                  maxLength={50}
                />
              </div>
              <div className="col-lg-12 p-2">
                <div className="d-flex align-items-inline">
                  <input className="form-check-input" type="checkbox"
                    id={`singleAnswerCheckbox-${qIndex}`}
                    checked={q.singleAnswer}
                    onChange={() => onSubQuestionSingleAnswerChange(qIndex, !q.singleAnswer)} />
                  <label className="form-check-label mx-1" htmlFor={`singleAnswerCheckbox-${qIndex}`}>
                    {t("SingleAnswer.label")}
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    );
  };

  const onAddQuestion = () => {
    setQuestion({
      question: "",
      helpText: "",
      sampleAnswer: "",
      code: "",
      children: [],
      singleAnswer: true
    });
  };


  const onAddNewSubQuestion = () => {
    const q = JSON.parse(JSON.stringify(question));
    if (!q.children) {
      q.children = [];
    }
    q.children.push({
      question: "",
      helpText: "",
      sampleAnswer: "",
      code: "",
      singleAnswer: true
    });
    setQuestion(q);
  };

  const onDeleteSubQuestion = (qIndex) => {
    const q = JSON.parse(JSON.stringify(question));
    if (q.children[qIndex]) {
      q.children.splice(qIndex, 1);
    }
    setQuestion(q);
  };

  const onSubQuestionCodeChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].code = val;
    setQuestion(q);
  };

  const onSubQuestionValChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].question = val;
    setQuestion(q);
  };

  const onSubQuestionHelpTextChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].helpText = val;
    setQuestion(q);
  };

  const onSubQuestionAnswerChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].sampleAnswer = val;
    setQuestion(q);
  };

  const onSubQuestionSingleAnswerChange = (index, val) => {
    const q = JSON.parse(JSON.stringify(question));
    q.children[index].singleAnswer = val;
    setQuestion(q);
  };

  const handleScopeChange = (e) => {
    const scopeName = e.target.value;
    setSelectedScope(scopeName);
    setSelectedCategory("");
    const selectedScopeData = scopeData.find((scope) => scope.name === scopeName);
    setCategoryData(
      selectedScopeData?.categories?.map((cat) => cat.name) ?? []
    );
  };

  const resetEmissionScopeSelection = () => {
    setSelectedScope("");
    setSelectedCategory("");
    setCategoryData([]);
    setScopeData([]);
  };

  const handleEmissionConfigChange = (config) => {
    setEmissionDatabase(config.database || "");
    setEmissionVersionRef(config.versionRef || "");
  };

  const handleEmissionToggle = () => {
    if (emission) {
      resetEmissionScopeSelection();
      setEmissionDatabase("");
      setEmissionVersionRef("");
    }
    setEmission(!emission);
  };

  const validateEmissionFields = () => {
    if (!emission) return true;
    if (!emissionDatabase || !emissionVersionRef || !selectedScope || !selectedCategory) {
      toast.error(t("EmissionFieldsRequired.label"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    return true;
  };

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="CreateMetric_card" id="idMetric" ref={containerRef}>
        <Form noValidate validated={validated}>
          <div className="row m-0 align-items-center">
            {
              answerMode &&
              renderAnswerModeFields()
            }
            {
              !answerMode &&
              renderEditModeFields()
            }

            <div className="col-lg-12 p-2 text-center">
              <button
                className="btn btn-secondary me-2"
                onClick={closeMetric}
              >
                {" "}
                {t("Discard.label")}
              </button>
              {isEdit ? (
                <button
                  className="btn btn-primary px-3"
                  onClick={handleEdit}
                >
                  {" "}
                  {t("Save.label")}
                </button>
              ) : (
                <button className="btn btn-primary px-3" onClick={saveData}>
                  {" "}
                  {t("Save.label")}
                </button>
              )}
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default withTranslation()(CreateMetric);
